export const copyright = '© 2021 Spout Software Inc. All rights reserved.';
